import * as Yup from 'yup';

export const checkr = Yup.string().max(
  50,
  'Checkr certificate should be less than 50 symbols',
);
